function setup() {

    console.log('lifecycle :', 'setup loading scene');

    this.$.timeout = 0;
}

export {setup};
